const styles = {
  backdrop: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#155239",
  },
  divStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "80vh",
  },
};

export default styles;
